export default __webpack_public_path__ + "static/media/neo4j.9f5e3f01.svg";